import { ReactNode, useEffect } from 'react'

import {
  useBackgroundReplacement,
  useMeetingManager,
  useVideoInputs,
} from 'amazon-chime-sdk-component-library-react'
import { isVideoTransformDevice } from 'amazon-chime-sdk-js'

type Props = {
  children: ReactNode
}

export function AutoBackgroundReplacement({ children }: Props): JSX.Element {
  const {
    isBackgroundReplacementSupported,
    createBackgroundReplacementDevice,
  } = useBackgroundReplacement()
  const { selectedDevice } = useVideoInputs()
  const meetingManager = useMeetingManager()
  useEffect(() => {
    if (
      !selectedDevice ||
      !isBackgroundReplacementSupported ||
      isVideoTransformDevice(selectedDevice)
    ) {
      return
    }
    createBackgroundReplacementDevice(selectedDevice)
      .then(device => meetingManager.startVideoInputDevice(device))
      .catch(err =>
        console.error('Failed to apply background replacement:', err),
      )
  }, [selectedDevice, isBackgroundReplacementSupported])

  return <>{children}</>
}
